module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-tokyo-1-c1d78bb23cf9cd5a656d3dbd45e14366.png";